<template>
	<div id="app" v-cloak :style="{
		'overflow-y': allowscroll ? 'auto' : 'hidden'
	}">
		<router-view></router-view>
		<back-to-top ref="backToTop"></back-to-top>
		<feedback></feedback>
		<faq></faq>
	</div>
</template>

<script>
import BackToTop from '@/components/BackToTop'
import Feedback from '@/components/Feedback'
import faq from '@/components/Faq';
import imgCrypto from '@kk/img-crypto';
export default {
	name: 'App',
	data() {
		return {
			allowscroll: true
		}
	},
	components: {
		BackToTop,
    Feedback,
		faq
	},
	created() {
		this.$store.dispatch('setEnvironment', this.environment())
		// 获取七牛token
		const getQiniuToken = options => {
			return new Promise(resolve => {
				const getTokenByNet = () => {
					let params = {}
					switch (options.type) {
						case 'comic':
							params = {
								method: 'get',
								url: '/author/image/qiniu/token'
							}
						break;
						case 'cover':
							params = {
								method: 'get',
								url: '/author/image/qiniu/cover_token'
							}
						break;
						case 'feed':
							params = {
								method: 'post',
								url: '/v1/feeds/pc/get_qiniu_key'
							}
						break;
						case 'live':
							params = {
								method: 'post',
								url: '/v1/live/get_qiniu_key_pc'
							}
						break;
						case 'post':
							params = {
								method: 'get',
								url: '/v1/graph/pc/partner/qiniuUploadToken',
                                params: {
                                    type: 3,
                                }
							}
						break;
						case 'material':
							params = {
								method: 'get',
								url: '/v1/graph/pc/partner/qiniuUploadToken',
                                params: {
                                    type: 4,
                                }
							}
						break;
						case 'practice':
							params = {
								method: 'get',
								url: '/submit/common/image/token'
							}
						break;
						case 'feedback':
							params = {
								method: 'get',
								url: '/v2/app/get_media_token',
								params: {
									scene: 11,
								}
							}
						break;
            case 'screenplay':
              params = {
								method: 'get',
								url: '/v2/app/get_media_token',
								params: {
									scene: 12,
								}
							}
            break;
						case 'ident':
							params = {
								method: 'get',
								url: '/web/user/real_info/file_token',
							}
						break;
            case 'contract':
							params = {
								method: 'post',
								url: '/v2/contract/upload_file',
							}
						break;
					}
					this.$axios(params).then(res => {
						const data = res.data
						localStorage.setItem(options.type + 'Time', new Date().getTime())
						localStorage.setItem(options.type + 'Token', data.token)
                        let base;
                        // 七牛图片上传
                        if (data.image_base) {
                            base = data.image_base;
                            base[base.length - 1] !== '/' && (base += '/');
                            localStorage.setItem(options.type + 'ImageBase', base);
                        }
                        // 七牛视频上传
                        if (data.video_base) {
                            base = data.video_base;
                            localStorage.setItem(options.type + 'VideoBase', base)
                        }

						resolve()
					})
				}

				let nowTime = new Date().getTime()
				if (options.type == 'comic' && options.comicId) {
					// 因为付费漫画和免费漫画的token不一样，所以每次都要重新获取
					this.$axios({
						method: 'get',
						url: '/author/image/qiniu/token',
						params: {
							comic_id: options.comicId
						}
					}).then(res => {
						const data = res.data
						localStorage.setItem(options.type + 'Token', data.token)
						localStorage.setItem(options.type + 'ImageBase', data.image_base)
						resolve()
					})
				} else {
					let qiniuTime = localStorage.getItem(options.type + 'Time') || false
					if (qiniuTime) {
						// 本地存储有内容
						if ((parseInt(nowTime) - parseInt(qiniuTime)) < 1800000) {
							resolve()
						} else {
							// 超过半小时 - 清空本地存储
							localStorage.removeItem(options.type + 'Time')
							localStorage.removeItem(options.type + 'Token')
							localStorage.removeItem(options.type + 'ImageBase')
							getTokenByNet.call(this)
						}
					} else {
						// 本地存储为空
						getTokenByNet.call(this)
					}
				}
			})
		}

		// 计算upload时的speed和progress（在axios的onUploadProgress回调中反复执行）
		const progressComputed = params => {
			return new Promise(resolve => {
				const evt = params.evt
				const nowTime = new Date().getTime()
				const spendTime = nowTime - params.startTime
				const x = evt.loaded / 1024
				const y = spendTime / 1000
				const progress = x / y
				let speed
				if (progress > 1024) {
					speed = (progress / 1024).toFixed(2) + "Mb\/s"
				} else {
					speed = progress.toFixed(2) + "Kb\/s"
				}
				const percent = Math.round(evt.loaded * 100 / evt.total)
				resolve({ percent, speed })
			})
		}

		// file: 文件流 - 二选一
		// base64: base64编码 - 二选一
		// type: token类型 - 必
		// callback(): 上传完成回调，返回res.data - 必
		// error(): 验证没通过回调，返回错误msg - 选
		// progress: 进度回调 - 选
		// key值相关：
		// index: 递归的图片索引值 - 选（否则随机）
		// comicId: 漫画id - 选
        // crypto: Booean - 可选（上传CDN前是否加密）
		this.$root.bus.$on('uploadQiniuFile', options => {
			// 第一步：获取token
			getQiniuToken({
				type: options.type,
				comicId: options.comicId,
			}).then(async () => {
				// 第二步：上传七牛
				const file = options.file
				let base64 = options.base64
				const cIndex = options.index ? (options.index + '')[0] : Math.floor(Math.random() * 10)
				const cComic = options.comicId ? '/c' + options.comicId : ''
				const cDate = new Date().$format('yy-MM-dd')
				let key = `${options.isVideo ? 'video' : 'image'}${ cComic }/${ cDate }/${ this.$util.returnRandomStr(8) }${ cIndex }.`
				if (file) {
					key += file.name.split('.').pop()
				} else if (base64) {
					if (base64.indexOf('data:') === 0) {
						const baseary = base64.split(';base64,')
						base64 = baseary[1]
						key += baseary[0].substring(baseary[0].indexOf('/') + 1)
					} else {
						key += 'png'
					}
				}
				const token = localStorage.getItem(options.type + 'Token')
				const startTime = new Date().getTime()

				let params = {
					method: 'post',
					handleError: true,
					url: location.protocol + '//upload.qiniup.com',
					onUploadProgress: evt => {
						if (options.progress && evt.lengthComputable) {
							progressComputed({
								evt,
								startTime
							}).then(res => {
								options.progress(res)
							})
						}
					}
				}
				if (file) {
					let formData = new FormData()
					formData.append('token', token)
                    if(options.crypto) {
                        const blob = await imgCrypto.scrypt(file);
                        formData.append('file', blob);
                    } else {
                        formData.append('file', file)
                    }
					formData.append('key', key)
					params.data = formData
				} else if (base64) {
					key = new Base64().encode(key)
					key = key.replace(/\+/g, '-')
					key = key.replace(/\//g, '_')
					params.url += `/putb64/-1/key/${ key }`
					params.headers = {
						'Content-Type': 'application/octet-stream',
						'Authorization': `UpToken ${ token }`
					}
					params.data = base64
				}
				if (options.isTencent) {
					options.uploadTencentCallback({key, file})
				}
				this.$axios(params).then(res => {
					options.callback(res.data)
				}).catch(e => {
					if (e && e.response && e.response.data && e.response.data.error) {
						this.$message.error(e.response.data.error)
						if (options.error) {
							options.error()
						}
					}
				})
			})
		})

		function Base64() {
			// private property
			let _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

			// private method for UTF-8 encoding
			let _utf8_encode = function(string) {
				string = string.replace(/\r\n/g, '\n');
				var utftext = '';
				for (var n = 0; n < string.length; n++) {
					var c = string.charCodeAt(n);
					if (c < 128) {
						utftext += String.fromCharCode(c);
					} else if ((c > 127) && (c < 2048)) {
						utftext += String.fromCharCode((c >> 6) | 192);
						utftext += String.fromCharCode((c & 63) | 128);
					} else {
						utftext += String.fromCharCode((c >> 12) | 224);
						utftext += String.fromCharCode(((c >> 6) & 63) | 128);
						utftext += String.fromCharCode((c & 63) | 128);
					}

				}
				return utftext;
			}

			// private method for UTF-8 decoding
			let _utf8_decode = function(utftext) {
				var string = '';
				var i = 0;
				var c = c1 = c2 = 0;
				while (i < utftext.length) {
					c = utftext.charCodeAt(i);
					if (c < 128) {
						string += String.fromCharCode(c);
						i++;
					} else if ((c > 191) && (c < 224)) {
						c2 = utftext.charCodeAt(i + 1);
						string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
						i += 2;
					} else {
						c2 = utftext.charCodeAt(i + 1);
						c3 = utftext.charCodeAt(i + 2);
						string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
						i += 3;
					}
				}
				return string;
			}

			// public method for encoding
			this.encode = function(input) {
				var output = '';
				var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
				var i = 0;
				input = _utf8_encode(input);
				while (i < input.length) {
					chr1 = input.charCodeAt(i++);
					chr2 = input.charCodeAt(i++);
					chr3 = input.charCodeAt(i++);
					enc1 = chr1 >> 2;
					enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
					enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
					enc4 = chr3 & 63;
					if (isNaN(chr2)) {
						enc3 = enc4 = 64;
					} else if (isNaN(chr3)) {
						enc4 = 64;
					}
					output = output +
						_keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
						_keyStr.charAt(enc3) + _keyStr.charAt(enc4);
				}
				return output;
			}

			// public method for decoding
			this.decode = function(input) {
				var output = '';
				var chr1, chr2, chr3;
				var enc1, enc2, enc3, enc4;
				var i = 0;
				input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
				while (i < input.length) {
					enc1 = _keyStr.indexOf(input.charAt(i++));
					enc2 = _keyStr.indexOf(input.charAt(i++));
					enc3 = _keyStr.indexOf(input.charAt(i++));
					enc4 = _keyStr.indexOf(input.charAt(i++));
					chr1 = (enc1 << 2) | (enc2 >> 4);
					chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
					chr3 = ((enc3 & 3) << 6) | enc4;
					output = output + String.fromCharCode(chr1);
					if (enc3 != 64) {
						output = output + String.fromCharCode(chr2);
					}
					if (enc4 != 64) {
						output = output + String.fromCharCode(chr3);
					}
				}
				output = _utf8_decode(output);
				return output;
			}
		}
	},
	methods: {
		// 检查环境
		environment() {
			if (window.location.port) {
				// 本地环境 local
				return 'local'
			} else if (window.location.host == 'author.quickcan.cn') {
				// 测试环境 develop
				return 'develop'
			} else {
				// 正式环境 production
				return 'admin'
			}
		}
	}
}
</script>
